import { render, staticRenderFns } from "./BarNav.vue?vue&type=template&id=bbaec1ae&scoped=true"
import script from "./BarNav.vue?vue&type=script&lang=js"
export * from "./BarNav.vue?vue&type=script&lang=js"
import style0 from "./BarNav.vue?vue&type=style&index=0&id=bbaec1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbaec1ae",
  null
  
)

export default component.exports